import { Appointment } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postPassPromotionalMessage({
  aid,
}: Pick<Appointment, "aid">): Promise<TrystGenericResponse<undefined>> {
  const TRYST_HOST = GET_TRYST_HOST();
  const headers = new Headers();

  headers.append("accept", "application/json");
  headers.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers,
    credentials: "include",
  };
  try {
    const response = await fetch(
      `${TRYST_HOST}/pass/promo/${aid}`,
      requestOptions
    );

    let promoMsgResponse: TrystGenericResponse<undefined> =
      await response.json();
    const { success, error } = promoMsgResponse;

    if (!success) {
      throw new Error(error || "Failed to send pass promotional message.");
    }

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: "Failed to send pass promotional message.",
    };
  }
}
